export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6417.44bbcaa0.jpg";